<template>
  <!-- 收藏统计 -->
  <div class="priceLevel">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd('')">新增价格等级</el-button>
      </template>
    </page-header>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input style="width:200px;margin-right:5px" clearable
          placeholder="输入关键字" v-model="searchForm.name"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column label="序号" align="center">
        <template slot-scope="scope">
          <span>{{(currPage - 1) * pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="价格等级编号" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="name" label="价格等级名称" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" style="padding:2px 3px;" plain @click="handleAdd(scope.row)">编辑</el-button>
          <el-button type="danger" style="padding:2px 3px;" plain @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>

    <!-- 价格等级弹窗 -->
    <el-drawer
      :visible.sync="isPriceLevel"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl">
      <div class="drawer-header">价格等级</div>
      <el-scrollbar style="height:calc(100% - 90px);">
        <div class="drawer-form-wrap">
          <el-form :model="addForm" label-position="rigth" label-width="120px" :rules="addFormRule" ref="addForm">
            <el-form-item label="价格等级名称" prop="name">
              <el-input v-model="addForm.name"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js"

export default {
  name: 'priceLevel',
  data() {
    return {
      /**表格数据 */
      tableData:[],
      /**搜索表单 */
      searchForm:{
        name: ''
      },
      /**分页数据 */
      currPage:1,
      pageSize:20,
      allPage:0,
      isPriceLevel: false,
      addForm: {
        id: '',
        name: '',
      },
      addFormRule: {
        name: [mustFill]
      }
    }
  },
  mounted() {
    this.getTableData()
  },
  methods:{
    /**返回 */
    goBack() {
      this.$router.go(-1)
      this.$destroy()
    },
    /**获取表格数据 */
    getTableData(num){
      this.currPage = num == 1 ? 1 : this.currPage
      let data = {
        entId: window.localStorage.getItem('entId'),
        searchVal: this.searchForm.name,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      }
      this.$request({
        method: 'post',
        url: 'GoodsAdmin/GetPriceLevel',
        data: data,
      }).then(res => {
        this.tableData = []
        this.allPage = 0
        if(res.success){
          this.allPage = res.toTal
          this.tableData = (res.list || []).map(item => ({
            id: item.PriceCode, // 价格等级编号
            name: item.PriceName, // 价格等级名称
          }))
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    /**刷新数据 */
    handleRefresh(){
      this.getTableData()
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val
      this.getTableData()
    },
    handleDel(row){
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          entId: window.localStorage.getItem('entId'),
          priceLevel: row.id
        }
        this.$request({
          url: 'GoodsAdmin/DltPriceLevel',
          method: "post",
          data: data
        }).then(res => {
          if (res.success) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.handleRefresh()
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
      }).catch(() => {})
    },
    handleAdd(row){
      this.clearForm()
      if(row){
        for(let key in this.addForm){
          this.addForm[key] = row[key]
        }
      }
      this.isPriceLevel = true
    },
    clearForm(){
      for(let key in this.addForm){
        this.addForm[key] = ''
      }
      this.isPriceLevel = false
    },
    submit(){
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          let data = {
            entId: window.localStorage.getItem('entId'),
            priceCode: this.addForm.id,
            priceName: this.addForm.name,
          }
          this.$request({
            url: 'GoodsAdmin/EditorPriceLevel',
            method: "post",
            data: data
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.clearForm()
              this.handleRefresh()
            } else {
              this.$message({
                message: res.message,
                type: 'error'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.priceLevel{
  width: 100%;
  height: 100%;
}
</style>
